<template>
	<div class="masonry">
		<slot></slot>
	</div>
</template>

<style scoped>
.masonry {
	column-count: 1;
	column-gap: 2em;
}
@media (min-width: 1200px) {
	.masonry {
		column-count: 2;
	}
}
</style>
